module.exports = __webpack_public_path__ + "img/ga.3c5332cb.svg";